// extracted by mini-css-extract-plugin
export var fadeIn = "_kr-1";
export var modalContent = "_kr-3";
export var overlay = "_kr-0";
export var popoverContent = "_kr-2";
export var results = "_kr-5";
export var searchInputWrapper = "_kr-4";